import { Button, Flex, Image, Modal, Typography } from 'antd';
import React from 'react';
import OvertimeTicketImage from './OvertimeTicketImage';
import { ITicketFile } from 'src/types/helpdesk/ticket.type';
import { AttachOpenType } from '../OvertimeTicketDetail';
const { Text } = Typography;

interface Props {
  open: AttachOpenType;
  setOpen: React.Dispatch<React.SetStateAction<AttachOpenType>>;
}

export default function OvertimeTicketAttach({ open, setOpen }: Props) {
  const handleCloseModal = () => {
    setOpen({ isOpen: false });
  };

  return (
    <Modal
      title={<Text>Hình ảnh kết quả công việc</Text>}
      className='overtime-attach-modal'
      centered
      maskClosable={false}
      open={open.isOpen}
      onCancel={handleCloseModal}
      footer={[
        <Button key='back' onClick={handleCloseModal}>
          Đóng
        </Button>
      ]}
    >
      <Flex gap={5}>
        <Image.PreviewGroup>
          {open?.attachList?.map((item) => (
            <OvertimeTicketImage key={item.id} ticketAttachment={item as ITicketFile} />
          ))}
          {(open?.attachList?.length || 0) <= 0 && <Text>Không có hình ảnh</Text>}
        </Image.PreviewGroup>
      </Flex>
    </Modal>
  );
}
